import {Card, CardContent, Typography} from "@mui/material";
import FileUpload from "./FileUpload";

const FileUploadCard = ({onFileSelect}) => {
  return (
    <Card variant="outlined" sx={{height: "100%"}}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          📁 Cargar Archivo
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Sube una imagen (JPG, PNG, GIF, WebP) o un documento PDF para que la IA pueda analizarlo
        </Typography>
        <FileUpload onFileSelect={onFileSelect} />
      </CardContent>
    </Card>
  );
};

export default FileUploadCard;
